import { render } from "./pb-alumniregister.vue?vue&type=template&id=0a29d140"
import script from "./pb-alumniregister.vue?vue&type=script&lang=js"
export * from "./pb-alumniregister.vue?vue&type=script&lang=js"

import "./pb-alumniregister.vue?vue&type=style&index=0&id=0a29d140&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__